import Vue from "vue";
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'
Vue.use(VueRouter)


import home from '../views/home.vue' //首页
import policy from "../views/policy/policy.vue" //政策服务
const routes = [
	{
		//20251216修改
		path: '/',
		name: 'home',
		component: home
	},
	{
		//20251216修改
		path: '/home',
		name: 'home',
		component: home
	},
	// {
	// 	path: '/yctech',
	// 	name: 'yctech',
	// 	component: () => import('../views/workdesk/admin/yctechCreate.vue')
	// },
	{
		path: '/policy',
		name: 'policy',
		component: policy
	},
	{
		path: '/policyInfo',
		name: 'policyInfo',
		component: () => import('../views/policy/policyInfo.vue')
	},
	{
		path: '/serviceTable',
		name: 'serviceTable',
		component: () => import('../views/policy/serviceTable.vue')
	},
	{
		path: '/enterpriseTable',
		name: 'enterpriseTable',
		component: () => import('../views/policy/enterpriseTable.vue')
	},
	{
		path: '/supplyHall',
		name: 'supplyHall',
		component: () => import('../views/supplyHall/index.vue')
	},
	{
		path: '/supplyInfo',
		name: 'supplyInfo',
		component: () => import('../views/supplyHall/supplyInfo.vue')
	},
	{
		path: '/addValueService',
		name: 'addValueService',
		component: () => import('../views/addValueService/index.vue')
	},
	{
		path: '/serviceInfo',
		name: 'serviceInfo',
		component: () => import('../views/addValueService/serviceInfo.vue')
	},
	{
		path: '/newsCenter',
		name: 'newsCenter',
		component: () => import('../views/newsCenter/index.vue')
	},
	{
		path: '/newsInfo',
		name: 'newsInfo',
		component: () => import('../views/newsCenter/newsInfo.vue')
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/login/login.vue')
	},
	//20251216修改
	// {
	// 	path: '/',
	// 	name: 'prelogin',
	// 	component: () => import('../views/login/prelogin.vue')
	// },
	// {
	// 	path: '/premenu',
	// 	name: 'premenu',
	// 	component: () => import('../views/login/premenu.vue')
	// }, 
	{
		path: '/personalCenter',
		name: 'personalCenter',
		component: () => import('../views/workdesk/desk.vue')
		// component: () => import('../views/personal/personalCenter.vue')
	},{
		path: '/fileAccess',
		name: 'FileAccess',
		component: () => import('../views/fileAccess.vue'),
		meta: { requireAuth: true }
	},
]
const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			// 如果之前有保存滚动位置，则恢复到之前保存的位置
			return savedPosition;
		} else {
			// 否则，默认滚动到页面顶部
			return {
				x: 0,
				y: 0
			};
		}
	}
})


//添加以下代码
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

// 全局路由守卫：校验登录（token）
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    const token = Cookies.get('token')
    if (!token) {
      // 未登录跳登录页，登录后返回原文件页面
      // next({ path: '/', query: { redirect: to.fullPath } })
			next({path:'/'})
      return
    }
  }
  next()
})


export default router